import React from 'react';
interface ToggleProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  description?: string;
}
export function Toggle({
  label,
  checked,
  onChange,
  description
}: ToggleProps) {
  return <div className="flex items-start justify-between" data-id="element-320">
      {(label || description) && <div className="mr-4" data-id="element-321">
          {label && <label className="text-sm font-medium text-gray-900 cursor-pointer" onClick={() => onChange(!checked)} data-id="element-322">
              {label}
            </label>}
          {description && <p className="text-sm text-gray-500" data-id="element-323">{description}</p>}
        </div>}
      <button type="button" role="switch" aria-checked={checked} onClick={() => onChange(!checked)} className={`
          relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent 
          transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2
          ${checked ? 'bg-red-600' : 'bg-gray-200'}
        `} data-id="element-324">
        <span aria-hidden="true" className={`
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 
            transition duration-200 ease-in-out
            ${checked ? 'translate-x-5' : 'translate-x-0'}
          `} data-id="element-325" />
      </button>
    </div>;
}